import Cookies from 'js-cookie';

export const THEME_COOKIE_NAME = 'kalshi-theme';

export type Theme = 'light' | 'dark';

export function getThemeFromCookie(): Theme {
    if (typeof window === 'undefined') {
        return 'light';
    }
    const theme = Cookies.get(THEME_COOKIE_NAME);
    return theme === 'dark' ? 'dark' : 'light';
}

export function setThemeCookie(theme: Theme): void {
    if (typeof window === 'undefined') {
        return;
    }
    Cookies.set(THEME_COOKIE_NAME, theme, {
        expires: 365, // 1 year
        sameSite: 'lax',
        path: '/',
    });
}

export function getServerThemeFromCookie(cookieHeader: string): Theme {
    if (!cookieHeader) {
        return 'light';
    }

    // parse cookie header: "key1=value1; key2=value2"
    const cookies = cookieHeader.split(';').reduce(
        (acc, cookie) => {
            const [key, value] = cookie.trim().split('=');
            if (key && value) {
                acc[key] = value;
            }
            return acc;
        },
        {} as Record<string, string>,
    );

    const theme = cookies[THEME_COOKIE_NAME];
    return theme === 'dark' ? 'dark' : 'light';
}

export function removeThemeCookie(): void {
    if (typeof window === 'undefined') {
        return;
    }
    try {
        Cookies.remove(THEME_COOKIE_NAME, { path: '/' });
    } catch {
        // `document.cookie` access throws in an opaque sandboxed iframe. This runs
        // from the forced-disconnect teardown ahead of the work that ends the
        // session, so losing a theme preference must not stop it.
    }
}
